export default __webpack_public_path__ + "static/media/readme-generator.0707d588.png";